import Swiper from 'swiper';
import { whenElementReady } from '../../../../application/typescript/utils/utils';

class PushTemoignages {
  constructor() {
    this._init();
  }

  _init() {
    whenElementReady('.push-temoignages__swiper', () => {
      new Swiper('.push-temoignages__swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 20,
        grabCursor: true,
        mousewheel: true,
        preventInteractionOnTransition: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 32
          }
        }
      });
    });
  }
}

export const pushTemoignages = new PushTemoignages();
